import React from 'react'

export default function LocalLawLink({ url }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="local-law-link"
    >
      read more about the local law &gt;
    </a>
  )
}
